// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"8e52e5a2","124":"51bc141e","146":"049bcb7a","363":"b865a38a","397":"b6368dcc","424":"f8de9f7d","493":"4c636b9b","658":"ac995fe7","895":"afca0e7c","896":"6a8a455b","942":"93289c9a"}[chunkId] + ".chunk.js";
};